// File: frontend/src/components/Leads/LeadCard.jsx
// Mobile card representation of a single lead (rendered below the md breakpoint).

import React from 'react';
import { Link } from 'react-router-dom';
import { TagsDisplay } from '../Tags/TagManager';
import { getScoreColor, formatLeadScore, formatDate } from './leadFormat';

const LeadCard = ({ lead, onArchive, archivedView = false }) => {
  const isConverted = lead.lead_status === 'converted';
  const isCustomer = lead.lifecycle_stage === 'customer';

  return (
    <div className="border-b border-gray-200 p-4 hover:bg-gray-50">
      <div className="flex items-start justify-between">
        <div className="min-w-0">
          <div className="text-sm font-medium text-gray-900">
            {lead.first_name} {lead.last_name}
          </div>
          <div className="text-sm text-gray-500 truncate">{lead.email}</div>
        </div>
        <span
          className={`ml-2 flex-shrink-0 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getScoreColor(
            lead.lead_score
          )}`}
        >
          {formatLeadScore(lead.lead_score)}
        </span>
      </div>

      <div className="mt-2 flex flex-wrap items-center gap-2">
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
          {lead.lead_status}
        </span>
        {lead.lead_source && (
          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-700">
            {lead.lead_source}
          </span>
        )}
        <TagsDisplay tags={lead.tags || []} size="xs" maxVisible={2} showCount={true} />
      </div>

      <div className="mt-2 text-xs text-gray-500">
        {lead.company_name || '-'} · {formatDate(lead.created_at)}
      </div>

      <div className="mt-3 flex items-center gap-2">
        <Link
          to={`/leads/${lead.id}`}
          className="flex-1 text-center text-blue-600 hover:text-blue-900 px-3 py-2 rounded text-sm border border-blue-200"
        >
          Ver detalhes
        </Link>
        {!isConverted && !isCustomer && (
          <Link
            to={`/leads/${lead.id}`}
            className="flex-1 text-center text-green-600 hover:text-green-900 px-3 py-2 rounded text-sm border border-green-300 hover:bg-green-50"
          >
            Converter
          </Link>
        )}
        {isConverted && (
          <span className="flex-1 text-center text-green-600 px-3 py-2 rounded text-sm bg-green-50 border border-green-200">
            Convertido
          </span>
        )}
        <button
          type="button"
          onClick={() => onArchive?.(lead)}
          className="flex-shrink-0 text-sm font-medium text-gray-600 hover:text-gray-900 px-3 py-2 rounded border border-gray-300"
        >
          {archivedView ? 'Desarquivar' : 'Arquivar'}
        </button>
      </div>
    </div>
  );
};

export default LeadCard;
